import { Button } from 'react-bootstrap'
import { IoDocumentOutline } from 'react-icons/io5'

import { numberFormatCurrency } from '../../utils/helpers'
import { formatToLocalTime } from '../../utils/dates'
import { discountPercent, taxPercent, taxTotal } from '../../utils/invoice'
import { useApi, useLoading } from '../../hooks' 
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

const ViewDesktop = ({ record = {}, isInvoice = false }) => {
	const { total = 0, number, dateCreated, createdBy = {}, client, currency = 'usd', discountAmount = 0, _id } = record

	const { pdfService } = useApi()

	const { isLoading, mutate: downloadPdf } = useMutation(pdfService.downloadPDF, {
		onError: (error) => toast.error(error.message)
	})

	useLoading(isLoading)

	return (
		<div className='px-4 d-flex align-items-center'>
			<div className='d-inline-flex flex-column px-4'>
				<h4 className='fw-bold px-3'>{isInvoice ? 'Invoice' : 'Estimate'}</h4>
				<Button
					variant='default'
					className='text-start fs-sub text-primary px-3 py-0 fw-bold text-uppercasse'
					onClick={() => downloadPdf({ invoiceId: _id })}
				>
					View PDF
					<IoDocumentOutline size={16} className='ms-2' />
				</Button>
			</div>

			<div className='d-inline-flex ps-4 border-start flex-grow-1'>
				<div className='px-3 d-flex flex-column '>
					<strong className='fs-base'>{isInvoice ? 'Invoice Total' : 'Estimate Total'}</strong>
					<span className='fs-base mt-2'>{numberFormatCurrency('usd', total)}</span>
					<span className='fs-small'>Tax ({taxPercent(record)}): {taxTotal(record)}</span>
					<span className='fs-small'>Discount ({discountPercent(record)}): {numberFormatCurrency(currency, discountAmount)}</span>
				</div>
			</div>
      <div className='pe-4 '>
        <div className='pe-3 d-flex flex-column'>
          <strong className='d-block text-end fs-base'>#{number} · {formatToLocalTime(dateCreated)}</strong>
          <span className='d-block text-end fs-small'>Created by: {createdBy.name || '[MTRX User]'}</span>
          <span className='d-block text-end fs-small'>for: {client.name || '[Client Name]'}</span>
        </div>
      </div>
    </div>
	)
}

export default ViewDesktop
